import { DefaultQueryParams, PaginatedResponse } from '@frontend/api-utils';

export interface ColliUser {
    user_id: string;
    type: ColliUserType;
    update_timestamp: string;
    id: string;
    account_id: string;
    transaction_id: string;
    colli_id: string;
    creation_timestamp: string;
}

export interface CreateColliUser {
    user_id?: string;
    type?: ColliUserType;
}

export enum ColliUserType {
    RECEIVER = 'receiver',
    SENDER = 'sender',
    DROPPED_OFF_BY = 'dropped_off_by',
    PICKED_UP_BY = 'picked_up_by',
    INITIATED_BY = 'initiated_by',
    REVIEWED_BY = 'reviewed_by',
    REMOVER = 'remover',
    HANDED_OFF_BY = 'handed_off_by'
}

enum QueryParams {
    ACCOUNT_ID = 'account_id',
    TRANSACTION_ID = 'transaction_id',
    COLLI_ID = 'colli_id',
    USER_ID = 'user_id',
    TYPE = 'type'
}

export type ColliUserQueryParams = QueryParams & DefaultQueryParams;
export type ColliUserListResponse = PaginatedResponse<ColliUser>;
